import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { flatten, uniq, values } from "lodash";
import { Loader } from "semantic-ui-react";

import {
    ManagerSatisfactionFollowUpQuestionnaireRequestDto,
    MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE
} from "@teamprevent/common/managerSatisfactionFollowUpQuestionnaire/models";
import {
    ManagerSatisfactionFollowUpQuestionnaire
} from "@teamprevent/common/managerSatisfactionFollowUpQuestionnaire/components/ManagerSatisfactionFollowUpQuestionnaire";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";

import { ApplicationState } from "../../applicationState";
import { satisfactionFollowUpQuestionnaireApi } from "../satisfactionFollowUpQuestionnaireApi";

export const SatisfactionFollowUpQuestionnaire: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [request, setRequest] = React.useState<ManagerSatisfactionFollowUpQuestionnaireRequestDto>(null);

    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const taskId = useSelector((state: ApplicationState) => state.router.params?.taskId);
    const ohCase = useSelector((state: ApplicationState) => state.ohCases.find(c => c.id === ohCaseId));
    const employeeRecordId = ohCase?.employeeRecordId;
    const task = ohCase?.tasks?.find(t => t.id === taskId);
    const managerViewReportTask = ohCase?.tasks?.find(t => t.id === task.precedingTaskId);
    const writeReportTask = ohCase?.tasks?.find(t => t.id === managerViewReportTask.precedingTaskId);
    const writeReportTaskId = writeReportTask?.id;

    const stateQuestionnaire = useSelector((state: ApplicationState) => state.questionnaires[MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE]);
    const questions: AnsweredQuestionWithId[] = uniq(flatten(stateQuestionnaire?.sections?.map(section => values(section.questions))));

    React.useEffect(() => {
        (async () => {
            if (customerId && ohCaseId && taskId) {
                const data = await satisfactionFollowUpQuestionnaireApi.getQuestionnaireRequest(customerId, ohCaseId, taskId);
                dispatch(questionnaireLoaded({
                    questions: data.questionnaireData.questions,
                    questionnaireKey: MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE
                }));
                setRequest(data);
            }
        })();
    }, [customerId, ohCaseId, taskId]);

    if (ohCase && task && request) {
        return (
            <ManagerSatisfactionFollowUpQuestionnaire
                ohCase={ohCase}
                task={task}
                reportLink={`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/${ohCaseId}/${writeReportTaskId}/referralReport`}
                request={request}
                questions={questions}
            />
        );
    }

    return <Loader active />;
};
